import React, { Component } from 'react'
import '../OnlineHelpPage.css'
import LongAngLatImg from './img/LongAndLat.png'

export default class LongAndLat extends Component {
  render() {
    return (
      <div className="main-window">
        <div className="main-window-title">使用经纬线功能</div>
        <img src={LongAngLatImg} className="main-window-img"></img>
      </div>
    )
  }
}
